<template>
  <div class="mb-4">
    <h5 class="title">マッチングアプリ設定</h5>
    <div class="container">
      <div class="d-flex justify-content-between form-switch form-check ps-0 mt-2">
        <label class="form-check-label form-title" for="use-matching-app">マッチングアプリ機能の利用</label>
        <input class="form-check-input" id="use-matching-app" type="checkbox" v-model="matching_mode" true-value="on" false-value="off">
      </div>
      <div class="description mt-3" v-if="scene=='wedding'">
        この結婚式では式中に参列者同士でマッチングアプリ機能を使うことができます。
      </div>
      <div class="description mt-3" v-else>
        このパーティーでは参加者同士でマッチングアプリ機能を使うことができます。
      </div>
      <hr>
      <template v-if="matching_mode == 'on'">
        <div class="mt-2">
          <div class="d-flex justify-content-between form-switch form-check ps-0">
            <label class="form-check-label form-title" for="mail-notification">メール通知</label>
            <input class="form-check-input" id="mail-notification" type="checkbox" v-model="email_notify" true-value="true" false-value="false">
          </div>
        </div>
        <div class="description mt-3">
          メッセージを受け取ったらメールで通知
        </div>
        <hr>
        <div class="mt-2">
          <label class="form-check-label form-title">プロフィール</label>
        </div>
        <div class="mt-2">
          <textarea class="form-control" id="profile-form" v-model="matching_profile" />
        </div>
        <hr>
        <div class="mt-2">
          <label class="form-check-label form-title">性別</label>
        </div>
        <div class="row mt-2">
          <div class="col gender-selection mx-1 text-center py-3"
            :selected="this.gender==='male'"
            @click="setGender('male');">男</div>
          <div class="col gender-selection mx-1 text-center py-3"
            :selected="this.gender==='female'"
            @click="setGender('female');">女</div>
        </div>
        <hr>
        <div class="mt-3">
          <label class="form-check-label form-title">Gmailアドレス</label>
        </div>
        <div class="mt-3 mb-4">
          <input type="email" id="email-form" class="form-control" placeholder="example@gmail.com" v-model="email" />
        </div>
      </template>
      <div class="mb-1">
        <button
          type="button"
          class="btn btn-green btn-lg d-block w-100 rounded-pill"
          @click="submit">
          <i class="mio"> save </i>
          保存
        </button>
      </div>
    </div>
  </div>
</template>

<script>
const KEYS = ['matching_mode', 'matching_profile', 'gender', 'email_notify', 'email']

export default {
  props: ['guest', 'scene'],
  data() {
    const data = {}
    for (let key of KEYS) {
      data[key] = null
    }
    return data
  },
  mounted() {
    for (let key of KEYS) {
      this[key] = this.guest[key]
    }
  },
  methods: {
    setGender(gender) {
      this.gender = gender;
    },
    submit() {
      const values = {}
      for (let key of KEYS) {
        values[key] = this[key]
      }
      this.$emit('submit', { guest: values })
    }
  },
  computed: {
  }
}
</script>

<style scoped>
.form-title {
  font-weight: 700;
}
.description {
  font-size: 14px;
}
.gender-selection {
  background: rgb(212, 212, 212);
  color: rgb(115, 115, 115);
  border-radius: 6px;
}
.gender-selection[selected=true] {
  background-color: black;
  color: white;
}
#profile-form {
  border: 1px solid rgb(245, 245, 245);
  background: rgb(245, 245, 245);
  height: 66px;
  border-radius: 6px;
}
</style>
